<template>
    <div class="scroll-con">
        <div class="header">
            <!-- 主菜单 -->
            <div class="header-menu" :class="{ 'header-menu-change-search': isChangeSearch }">
                <router-link v-if="sisadmin" active-class="active" to="/devsetting">管理员</router-link>
                <router-link active-class="active" to="/autopricesetting">出价配置</router-link>
                <router-link active-class="active" to="/autopricecheck">暗拍审核</router-link>
                <router-link active-class="active" to="/multiplecate">多品类出价(测试中)</router-link>
                <router-link active-class="active" to="/realtimedark">实时竞拍(开发中)</router-link>
                <router-link active-class="active" to="/" @click="showinfo">闲鱼采货(未开放)</router-link>
            </div>

            <!-- 头像区域 -->
            <div class="header-profile">
                <!-- 搜索框 -->
                <div class="search-bar" :class="{ 'search-bar-change-search': isChangeSearch }">
                    <input
                        type="text"
                        @focusin="changeStyle"
                        @focusout="changeStyle"
                        placeholder="验机码查询-历史出价"
                        ref="stickcodeInput"
                        @keyup.enter="handleEnterKey"
                        v-model="stickcode" />
                </div>

                <!-- 登出 -->
                <a title="logout" href="#" @click="logout" style="align-items: center; margin-left: 22px">
                    <svg t="1719247580444" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3449" width="200" height="200">
                        <path d="M64 64h512v256H256v384h320v256H64V64z" fill="#ffffff" p-id="3450"></path>
                        <path d="M704 448V256h64l256 256-256 256h-64V576H384V448h320z" fill="#ffffff" p-id="3451"></path>
                    </svg>
                </a>

                <!-- 时间 -->
                <div class="clock">
                    <p class="date">{{ sname }} {{ date }} {{ time }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Bus from "@/router/bus";
    import { SseService } from "@/utils/sseService.ts";
    export default {
        data() {
            return {
                sisadmin: false,
                sname: localStorage.nickname,
                isChangeSearch: false,
                stickcode: "",
                time: "",
                date: "",
                week: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
                tips: [],
                reConnectCnt: 3,
            };
        },
        created() {
            Bus.on("changeMsg", (data) => {
                this.sname = localStorage.nickname;
                this.checkname();
            });
        },
        methods: {
            showinfo() {
                this.$message({
                    message: "闲鱼采货功能未开放，敬请期待！",
                    type: "warning",
                });
            },
            checkname() {
                if (localStorage.authRoleVOList != null) {
                    this.sisadmin = localStorage.authRoleVOList.includes("管理员");
                } else {
                    this.sisadmin = false;
                }
            },
            socketInit() {
                this.ws = null;
                // WebSocket服务器的URL
                let userId = localStorage.getItem("loginId");
                // const websocketUrl = "ws://47.109.68.137:6200/pv/pushMessage?userId=" + userId;
                // 配置了证书
                const websocketUrl = "wss://hx2s.com/pv/pushMessage?userId=" + userId;
                this.ws = new WebSocket(websocketUrl);
            },
            handleWsOpen() {
                // let data = {
                //   type: "1",
                // };
                // this.ws.send(JSON.stringify(data));
            },
            handleWsClose(e) {
                //断线重连
                if (this.reConnectCnt >= 0) {
                    this.reConnectCnt = this.reConnectCnt - 1;
                    setTimeout(this.socketInit, 2000);
                }
            },
            handleWsError(e) {},
            handleWsMessage(e) {
                //这里是 服务器端发回的消息 解析逻辑 并成功给出提示
                let ret = e.data;
                this.tips.push(ret);
            },
            // 下单与websocket通信并且提示
            getTips() {},
            // 删除下单提醒条数
            delClo(index) {
                this.tips.splice(index, 1);
            },
            //时间
            updateTime() {
                const date = new Date();
                this.time = this.zeroPadding(date.getHours(), 2) + ":" + this.zeroPadding(date.getMinutes(), 2) + ":" + this.zeroPadding(date.getSeconds(), 2);
                this.date =
                    this.zeroPadding(date.getFullYear(), 4) +
                    "-" +
                    this.zeroPadding(date.getMonth() + 1, 2) +
                    "-" +
                    this.zeroPadding(date.getDate(), 2) +
                    " " +
                    this.week[date.getDay()];
            },
            zeroPadding(num, digit) {
                let zero = "";
                for (let i = 0; i < digit; i++) {
                    zero += "0";
                }
                return (zero + num).slice(-digit);
            },

            handleEnterKey() {
                // 处理回车键按下时的逻辑
                if (this.stickcode === null) {
                    this.newtab();
                } else if (this.stickcode.trim() !== "") {
                    const url = this.$router.resolve({ path: "/purhistory", query: { stickcode: this.stickcode } }).href;
                    const newTab = window.open(url, "_blank");
                    // 在新标签页中存储旧标签页的引用
                    newTab.opener = window;
                }
                // 失去焦点
                this.$refs.stickcodeInput.blur();
            },
            newtab() {
                const url = this.$router.resolve("/purhistory").href;
                const newTab = window.open(url, "_blank");
                // 在新标签页中存储旧标签页的引用
                newTab.opener = window;
            },

            logout(e) {
                e.preventDefault();
                localStorage.authRoleVOList = null;
                localStorage.tokenName = null;
                localStorage.nickname = null;
                localStorage.loginId = null;

                this.isAuth = "false";
                localStorage.s = "false";
                localStorage.sa = null;
                this.sname = "";
                this.sisadmin = false;
                this.$router.replace("/login");
                const sseService = new SseService();
                sseService.close();
            },
            changeStyle() {
                this.isChangeSearch = !this.isChangeSearch;
                this.stickcode = null;
            },
        },
        mounted() {
            this.checkname();

            this.sname = localStorage.nickname;
            // this.socketInit();
            setInterval(this.updateTime, 1000);
            this.updateTime();

            //好好学闭包
            let me = this;
            //心跳检测
            // setInterval(function () {
            //     me.ws.send("");
            // }, 1000 * 100);
        },
        computed: {
            formattedDate() {
                if (this.selectedDate) {
                    const date = new Date(this.selectedDate);
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从0开始，需要加1
                    const day = String(date.getDate()).padStart(2, "0");
                    return `${year}${month}${day}`;
                }
                return "";
            },
        },
    };
</script>

<style lang="scss" scoped>
    .clock {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        //overflow: auto;
        color: #ffffff;
        font-family: "Share Tech Mono", monospace;
        text-shadow: 0 0 20px rgb(78, 179, 213), 0 0 20px rgba(10, 175, 230, 0);

        p {
            margin: 0;
        }

        .time {
            letter-spacing: 0.05em;
            font-size: 12px;
            padding: 5px 0;
        }

        .text {
            letter-spacing: 0.1em;
            font-size: 12px;
            padding: 20px 0 0;
        }
    }

    // todo 记得删除--和外层 div
    .header {
        background: -webkit-linear-gradient(left, rgb(145, 217, 246) 0%, #db6ff3 100%);
        display: flex;
        align-items: center;
        //flex-shrink: 0;
        height: 58px;
        width: 100%;
        border-bottom: 1px solid rgba(113 119 144 / 25%);
        padding: 0 30px;
        white-space: nowrap;
        /* 防止内容换行 */

        @media screen and (max-width: 480px) {
            padding: 0 16px;
        }

        .logo {
            width: 96px;
            height: 30px;
            margin-right: 110px;
            flex-shrink: 0;
            display: flex;
            flex-direction: row;
            align-items: center;

            @media screen and (max-width: 945px) {
                display: none;
            }

            h2 {
                background-image: linear-gradient(rgb(221, 224, 38), rgb(236, 17, 36), rgb(241, 50, 216));
                background-clip: text;
                -webkit-background-clip: text;
                color: transparent;
                display: flex;
            }
        }

        /* .head-menu */
        &-menu {
            display: flex;
            align-items: center;

            a {
                padding: 20px 30px;
                text-decoration: none;
                color: rgb(60, 62, 70);
                border-bottom: 2px solid transparent;
                transition: 0.3s;

                @media screen and (max-width: 610px) {
                    &:not(.main-header-link) {
                        display: none;
                    }
                }
            }

            a:hover,
            a.active {
                color: #ffffff;
                border-bottom: 2px solid #ffffff;
            }
        }

        .notify {
            position: relative;

            &:before {
                content: "";
                position: absolute;
                background-color: #3a6df0;
                width: 6px;
                height: 6px;
                border-radius: 50%;
                right: 20px;
                top: 16px;
            }

            @media screen and (max-width: 1055px) {
                display: none;
            }
        }

        .search-bar {
            height: 40px;
            display: flex;
            width: 100%;
            max-width: 400px;
            padding-left: 16px;
            border-radius: 4px;
            border: none;

            input {
                width: 100%;
                height: 100%;
                border: none;
                outline: none;
                background-color: #b7bbea;
                background-color: white;
                border-radius: 4px;
                font-family: "Poppins", sans-serif;
                font-size: 15px;
                font-weight: 500;
                padding: 0 20px 0 40px;
                //box-shadow: 0 0 0 2px rgb(134 140 160 / 0%);
                background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 56.966 56.966' fill='%23717790c7'%3e%3cpath d='M55.146 51.887L41.588 37.786A22.926 22.926 0 0046.984 23c0-12.682-10.318-23-23-23s-23 10.318-23 23 10.318 23 23 23c4.761 0 9.298-1.436 13.177-4.162l13.661 14.208c.571.593 1.339.92 2.162.92.779 0 1.518-.297 2.079-.837a3.004 3.004 0 00.083-4.242zM23.984 6c9.374 0 17 7.626 17 17s-7.626 17-17 17-17-7.626-17-17 7.626-17 17-17z'/%3e%3c/svg%3e");
                background-size: 14px;
                background-repeat: no-repeat;
                background-position: 16px 48%;

                //color: #212324;
                &::placeholder {
                    font-family: "Poppins", sans-serif;
                    color: rgb(131, 131, 237);
                    font-size: 15px;
                    font-weight: 500;
                }
            }

            input:focus {
                border: 2px solid rgb(192, 134, 192);
            }
        }

        .header-profile {
            display: flex;
            align-items: center;
            padding: 0 16px;
            margin-left: auto;
            flex-shrink: 0;

            svg {
                width: 22px;
                color: #f9fafb;
                flex-shrink: 0;
            }

            .notification {
                margin-left: 22px;
                position: relative;
                top: 2px;

                &-number {
                    position: absolute;
                    background-color: #3a6df0;
                    width: 16px;
                    height: 16px;
                    border-radius: 50%;
                    font-size: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #fff;
                    right: -6px;
                    top: -6px;
                }

                & + svg {
                    margin-left: 22px;

                    @media screen and (max-width: 945px) {
                        display: none;
                    }
                }
            }

            .profile-img {
                width: 56px;
                height: 56px;
                border-radius: 50%;
                object-fit: scale-down;
                border: 2px solid #f9fafb;
                margin-left: 22px;
            }
        }

        /*输入框聚焦后，样式改变 */

        .search-bar-change-search {
            max-width: 600px;
            margin: auto;
            transition: 0.4s;
            box-shadow: 0 0 0 1px rgba(113 119 144 / 25%);
            padding-left: 0;
        }

        .change-search {
            .header-menu,
            .header-profile {
                display: none;
            }

            .search-bar {
                max-width: 600px;
                margin: auto;
                transition: 0.4s;
                box-shadow: 0 0 0 1px rgba(113 119 144 / 25%);
                padding-left: 0;
            }

            .logo {
                margin-right: 0;
                margin-bottom: 0;
            }
        }
    }
</style>
